<template lang="pug">
  el-dialog(
    :visible.sync="dialogVisible"
    :width="dialogWidth"
    class="custom-dialog-logout"
    top="5vh"
    :close-on-click-modal="false"
  )
    div(slot="title") Cadastro Incompleto
    .conteudo
      div <strong>{{ getFirstName }}</strong>, percebi que você está com o cadastro incompleto!
      div Para que você possa utilizar todos os recursos da aplicação, finalize seu cadastro.
      .btns
        el-button(type="primary" @click="completarCadastro") Finalizar Agora
        el-button(type="text" @click="setCadastroImcompleto(false)") mais tarde
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import LoginGoogle from '../LoginGoogle.vue'

export default {
name: 'ModalLogout',

components: {
  LoginGoogle
},

data(){
  return{
    currentDialogWidth: this.calculateDialogWidth()
  }
},

mounted() {
  window.addEventListener('resize', this.handleResize);
},
beforeDestroy() {
  window.removeEventListener('resize', this.handleResize);
},

computed: {
  ...mapGetters({
    getCadastroImcompleto: 'modais/getCadastroImcompleto',
    getUser: 'usuario/user'
  }),

  dialogVisible: {
    get(){
      return this.getCadastroImcompleto
    },
    set(newValue){
      this.setCadastroImcompleto(newValue)
    }
  },
  dialogWidth() {
    return this.currentDialogWidth;
  },
  getFirstName() {
    if(this.getUser) return this.getUser.nome.split(' ')[0]
    return 'Usuário'
  }
},

  methods: {
    ...mapMutations({
      setCadastroImcompleto: 'modais/setCadastroImcompleto',
      setEdicaoInformacoes: 'modais/setEdicaoInformacoes'
    }),
    calculateDialogWidth() {
      return window.innerWidth < 576 ? '90%' : '490px'
    },
    handleResize() {
      this.currentDialogWidth = this.calculateDialogWidth()
    },
    completarCadastro(){
      this.setEdicaoInformacoes(true)
      this.setCadastroImcompleto(false)
    }
  },
}
</script>

<style lang="scss">
.custom-dialog-logout {
background: rgba(0, 0, 0, .6);

  .el-dialog {
    border-radius: 10px;

    .el-dialog__header{
      padding: 20px;
      font-size: 18px;
      font-weight: 600;
      border-bottom: 1px solid #bcb8b8;

      .el-dialog__headerbtn{
        top: 19px;

        i{
          font-size: 30px;
        }
      }
    }

    .el-dialog__body{
      padding: 20px;

      .conteudo{
        & > div{
          font-size: 16px;
          text-align: center;
          margin: 15px 0;
          word-break: break-word;
        }
        .btns{
          margin-top: 30px;
        }
      }
    }

    .el-dialog__footer {
     display: none;
    }
  }
}
</style>